export const GET_CREDIT_NOTES = 'GET_CREDIT_NOTES';
export const GET_CREDIT_NOTE = 'GET_CREDIT_NOTE';
export const ADD_CREDIT_NOTE = 'ADD_CREDIT_NOTE';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const UPDATE_SEARCH = 'UPDATE_SEARCH_CREDITNOTES';
export const UPDATE_PAGE = 'UPDATE_PAGE_CREDITNOTES';
